/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetIssuedCardGlobals = {
  /**
   * Specify an API version.
   *
   * @remarks
   *
   * API versioning follows the format `vYYYY.QQ.BB`, where
   *   - `YYYY` is the year
   *   - `QQ` is the two-digit month for the first month of the quarter (e.g., 01, 04, 07, 10)
   *   - `BB` is the build number, starting at `.01`, for subsequent builds in the same quarter.
   *     - For example, `v2024.01.00` is the initial release of the first quarter of 2024.
   *
   * The `latest` version represents the most recent development state. It may include breaking changes and should be treated as a beta release.
   * When no version is specified, the API defaults to `v2024.01.00`.
   */
  xMoovVersion?: string | undefined;
};

export type GetIssuedCardRequest = {
  /**
   * The Moov business account for which the card was issued.
   */
  accountID: string;
  issuedCardID: string;
};

export type GetIssuedCardResponse = {
  headers: { [k: string]: Array<string> };
  result: components.IssuedCard;
};

/** @internal */
export const GetIssuedCardGlobals$inboundSchema: z.ZodType<
  GetIssuedCardGlobals,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-Moov-Version": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-Moov-Version": "xMoovVersion",
  });
});
/** @internal */
export type GetIssuedCardGlobals$Outbound = {
  "X-Moov-Version"?: string | undefined;
};

/** @internal */
export const GetIssuedCardGlobals$outboundSchema: z.ZodType<
  GetIssuedCardGlobals$Outbound,
  z.ZodTypeDef,
  GetIssuedCardGlobals
> = z.object({
  xMoovVersion: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xMoovVersion: "X-Moov-Version",
  });
});

export function getIssuedCardGlobalsToJSON(
  getIssuedCardGlobals: GetIssuedCardGlobals,
): string {
  return JSON.stringify(
    GetIssuedCardGlobals$outboundSchema.parse(getIssuedCardGlobals),
  );
}
export function getIssuedCardGlobalsFromJSON(
  jsonString: string,
): SafeParseResult<GetIssuedCardGlobals, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetIssuedCardGlobals$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetIssuedCardGlobals' from JSON`,
  );
}

/** @internal */
export const GetIssuedCardRequest$inboundSchema: z.ZodType<
  GetIssuedCardRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  accountID: z.string(),
  issuedCardID: z.string(),
});
/** @internal */
export type GetIssuedCardRequest$Outbound = {
  accountID: string;
  issuedCardID: string;
};

/** @internal */
export const GetIssuedCardRequest$outboundSchema: z.ZodType<
  GetIssuedCardRequest$Outbound,
  z.ZodTypeDef,
  GetIssuedCardRequest
> = z.object({
  accountID: z.string(),
  issuedCardID: z.string(),
});

export function getIssuedCardRequestToJSON(
  getIssuedCardRequest: GetIssuedCardRequest,
): string {
  return JSON.stringify(
    GetIssuedCardRequest$outboundSchema.parse(getIssuedCardRequest),
  );
}
export function getIssuedCardRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetIssuedCardRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetIssuedCardRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetIssuedCardRequest' from JSON`,
  );
}

/** @internal */
export const GetIssuedCardResponse$inboundSchema: z.ZodType<
  GetIssuedCardResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  Headers: z.record(z.array(z.string())).default({}),
  Result: components.IssuedCard$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "Headers": "headers",
    "Result": "result",
  });
});
/** @internal */
export type GetIssuedCardResponse$Outbound = {
  Headers: { [k: string]: Array<string> };
  Result: components.IssuedCard$Outbound;
};

/** @internal */
export const GetIssuedCardResponse$outboundSchema: z.ZodType<
  GetIssuedCardResponse$Outbound,
  z.ZodTypeDef,
  GetIssuedCardResponse
> = z.object({
  headers: z.record(z.array(z.string())),
  result: components.IssuedCard$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    headers: "Headers",
    result: "Result",
  });
});

export function getIssuedCardResponseToJSON(
  getIssuedCardResponse: GetIssuedCardResponse,
): string {
  return JSON.stringify(
    GetIssuedCardResponse$outboundSchema.parse(getIssuedCardResponse),
  );
}
export function getIssuedCardResponseFromJSON(
  jsonString: string,
): SafeParseResult<GetIssuedCardResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetIssuedCardResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetIssuedCardResponse' from JSON`,
  );
}
